import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '/api',
  timeout: 15000,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : '请求失败';
    return Promise.reject(new Error(message));
  },
);
